import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'hooks/redux';
// import { connect } from 'react-redux';
// import { State, Sneakers as SneakersType } from 'types';
// import { fetchHomepage } from 'store/ducks/homepage/actions';
// import { getHomepage, isLoading } from 'store/ducks/homepage/selectors';
// import { HomeStub } from './Home.stub';
import {
  Main,
  Newsfeed,
  Articles,
  Subscription,
  Others,
  Person,
  PageMeta,
  Page,
} from 'components';

import { getHomepage } from 'store/ducks/homepage/actions';

import { Video } from 'components/Video/Video';
import { Spb } from 'components/Spb/Spb';

const Home = () => {
  const dispatch = useDispatch();
  const pollId = useAppSelector(state => state.homepage.pollId);

  const { status } = useAppSelector(state => state.homepage);

  useEffect(() => {
    // A failed load is retried the next time the component mounts.
    if (status == 'IDLE' || status == 'FAILURE') {
      dispatch(getHomepage());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- load once on mount; the saga owns later refreshes.
  }, []);

  return (
    <Page>
      <PageMeta
        status=""
        title="Телеспутник – новости о телекоме, ИКТ, цифровизации, кибербезопасности и медиапотреблении"
        description="Телеспутник является одним из самых авторитетных и быстроразвивающихся интернет-порталов в области телевизионной индустрии, рынка OTT, медиапотребления и производства контента."
        url="https://telesputnik.ru"
      />
      <Main />
      <Newsfeed />
      <Articles />
      <Subscription page="" mod="" />
      <Others pollId={pollId} />
      <Video />
      <Spb />
      <Person />

      <div className="news">
        {/* {news.map(item => (
                    <div key={item.id}>{item.title}</div>
                ))} */}
      </div>
    </Page>
  );
};

export default Home;
